module.exports = __webpack_public_path__ + "static/img/f-two.4066130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-four/f-two.png
// module id = Q+3G
// module chunks = 0